<template>
  <div class="flex min-h-screen">
    <div :class="`lg:hidden overlay ${sidebarOpen ? 'block' : 'hidden'}`" @click="sidebarOpen = false"></div>
    <AmsSidebar :isOpen="sidebarOpen" class="z-50" />
    <div class="flex-grow w-full flex flex-col h-screen">
      <AmsHeader @click:sidebar-toggler="sidebarOpen = !sidebarOpen" class="flex-shrink-0" />
      <main class="flex-grow min-h-0 overflow-y-auto px-4 lg:px-20 xl:px-36" id="main-scroll-area">
        <transition name="fade" mode="out-in">
          <RouterView />
        </transition>
      </main>
    </div>
  </div>
</template>

<script>
import AmsHeader from "./components/AmsHeader.vue";
import AmsSidebar from "./components/AmsSidebar.vue";

export default {
  components: { AmsSidebar, AmsHeader },
  data() {
    return {
      sidebarOpen: false,
    };
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-enter-active {
  transition-delay: 0.1s; /* Adjust delay as needed */
}

.fade-enter-to {
  margin-top: 0px;
  opacity: 1;
}
.fade-enter-from {
  margin-top: 25px;
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
</style>